import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Pagination from '../pagination/Pagination'
import { Link } from 'react-router-dom'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { FaSearch } from 'react-icons/fa'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const ViewClub = () => {

  const [clubNumber, setClubNumber] = useState('')
  const [clubName, setClubName] = useState('')
  const [president, setPresident] = useState('')
  const [secretory, setSecretory] = useState('')
  const [treasurer, setTreasurer] = useState('')
  const [clubSponsoredBy, setClubSponsoredBy] = useState('')
  const [chartedOn, setChartedOn] = useState('')
  const [extn, setExtn] = useState('')
  const [meets, setMeets] = useState('')
  const [place, setPlace] = useState('')
  const [region, setRegion] = useState('')
  const [charter, setCharter] = useState('')
  const [zone, setZone] = useState('')
  const [totalMembers, setTotalMembers] = useState('')
  const [category, setCategory] = useState('')
const [showUpload, setShowUpload] = useState(false);
const [file, setFile] = useState(null);

const handleUploadClose = () => setShowUpload(false);
const handleUploadShow = () => setShowUpload(true);

const [presidentMobileNo, setPresidentMobileNo] = useState('');
const [secretaryMobileNo, setSecretaryMobileNo] = useState('');
const [treasurerMobileNo, setTreasurerMobileNo] = useState('');
const [regionMobileNo, setRegionMobileNo] = useState('');
const [zoneMobileNo, setZoneMobileNo] = useState('');
const [clubAdministrator, setClubAdministrator] = useState('');
const [clubAdminMobileNo, setClubAdminMobileNo] = useState('');

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [club, setClub] = useState([])
  const [getClubName, setGetClubName] = useState([])
  const [showPerPage, setShowPerPage] = useState(10)
  const [pagination, setPagination] = useState(
    {
      start: 0,
      end: showPerPage
    }
  )

  const onChangePagination = (start, end) => {
    setPagination({ start: start, end: end })
  }

  const dist = sessionStorage.getItem("dist");

  const clubData = async () => {
    const res = await axios.get(`https://lionsdirectoryapi.emedha.in/club/api/clubData?dist=${dist}`)
    setClub(res.data)
  }

  useEffect(() => {
    clubData()
  }, []);


  const downloadSample = () => {

  const sampleData = [
    {
      clubName: "Test01234",
      clubNumber: "1234",
      president: "PSD",
      president_mobileNo: "1234567952",
      secretory: "SEC",
      secretary_mobileNo: "1234567953",
      treasurer: "TRS",
      treasurer_mobileNo: "1234567954",
      clubAdministrator: "ADMIN",             // <-- Added field
      clubAdmin_mobileNo: "1234567956",
      clubSponsoredBy: "CSP",
      chartedOn: "2026-04-14",
      charterPresident: "CSP",
      extnChairperson: "EXC",
      meetsOn: "TEST",
      place: "TEST",
      regionChairperson: "RC",
      region_mobileNo: "1234567954",
      zoneChairperson: "ZC",
      zone_mobileNo: "1234567955",
      totalMembers: "55",
      category: "TEST"
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(sampleData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "SampleClub");

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const fileData = new Blob([excelBuffer], {
    type: "application/octet-stream"
  });

  saveAs(fileData, "Club_Bulk_Upload_Sample.xlsx");
};

const submitData = (e) => {
  e.preventDefault();
  const dist = sessionStorage.getItem("dist");
  const performedBy = sessionStorage.getItem("email");

  axios.post('https://lionsdirectoryapi.emedha.in/club/api/clubCreate', {
    clubNumber,
    clubName,
    president,
    presidentMobileNo,  // Add presidentMobileNo
    secretory,
    secretaryMobileNo, // Add secretaryMobileNo
    treasurer,
    treasurerMobileNo,
    clubAdministrator,    // <-- Added field
    clubAdminMobileNo,
    clubSponsoredBy,
    chartedOn,
    extn,
    place,
    meets,
    region,
    regionMobileNo, 
    charter,
    zone,
    zoneMobileNo,  
    totalMembers,
    category,
    dist,
    performedBy
  }).then(() => {
    alert('Data Successfully Inserted!');
    setShow(false);
    setTimeout(() => clubData(), 100);
  }).catch((err) => alert(err.response?.data || err.message));
};




const deleteData = (id) => {
  const dist = sessionStorage.getItem("dist");
const performedBy = sessionStorage.getItem("email");
  if (window.confirm('Are you sure to delete this data...')) {
    axios({
      method: 'DELETE',
      url: `https://lionsdirectoryapi.emedha.in/club/api/deleteClub`,
      data: { id, dist ,performedBy}
    }).then(() => {
      alert('Data deleted successfully!...');
      setTimeout(() => clubData(), 100);
    }).catch((err) => {
      alert('Error deleting data.');
      console.error(err);
    });
  }
};

const uploadBulk = () => {
  if (!file) {
    alert("Please select a file");
    return;
  }

  const dist = sessionStorage.getItem("dist");
  const performedBy = sessionStorage.getItem("email");

  const formData = new FormData();
  formData.append("excel", file);
  formData.append("dist", dist);
  formData.append("performedBy", performedBy);

  axios.post("https://lionsdirectoryapi.emedha.in/member/api/club/bulk-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
  .then((res) => {
    alert(res.data.message);
    setShowUpload(false);   // ✅ close modal
    setFile(null);          // ✅ reset file
    clubData();             // ✅ refresh table
  })
  .catch((err) => {
    alert("Upload failed");
    console.error(err);
  });
};

const searchHandler = (search) => {
  const dist = sessionStorage.getItem("dist"); // get dist from sessionStorage

  axios.post('https://lionsdirectoryapi.emedha.in/club/api/search/club', {
    search,
    dist
  }).then((resp) => {
    setClub(resp.data);
  }).catch(err => console.error("Search error:", err));
};





  return (

    <>
       <Button variant="primary" onClick={handleShow}>
        Add<PersonAddAltIcon></PersonAddAltIcon>
      </Button>

      <Button variant="success" onClick={handleUploadShow} className="ms-2">
  Bulk Upload
</Button>
<Button 
  variant="info" 
  className="ms-2"
  onClick={downloadSample}
>
  Download Bulk Upload Sample
</Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <br /><br /><br /><br /><br />
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitData}>
            <input type='number' className='form-control' placeholder='Club Number' required onChange={(e) => setClubNumber(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Club Name' required onChange={(e) => setClubName(e.target.value)} />

            <br />
            <input type='text' className='form-control' placeholder='President' onChange={(e) => setPresident(e.target.value)} />
            <br />
            <input
  type='text'
  className='form-control'
  placeholder='President Mobile No'
  onChange={(e) => setPresidentMobileNo(e.target.value)}
/>
<br />


            <input type='text' className='form-control' placeholder='Secretary' onChange={(e) => setSecretory(e.target.value)} />
            <br />
            <input
  type='text'
  className='form-control'
  placeholder='Secretary Mobile No'
  onChange={(e) => setSecretaryMobileNo(e.target.value)}
  />
           <br />

            <input type='text' className='form-control' placeholder='Treasurer' onChange={(e) => setTreasurer(e.target.value)} />
            <br />
            <input
  type='text'
  className='form-control'
  placeholder='Treasurer Mobile No'
  onChange={(e) => setTreasurerMobileNo(e.target.value)}
/>
<br />
<input 
              type='text' 
              className='form-control' 
              placeholder='Club Administrator' 
              onChange={(e) => setClubAdministrator(e.target.value)} 
            />
            <br />
            <input 
              type='text' 
              className='form-control' 
              placeholder='Club Administrator Mobile No' 
              onChange={(e) => setClubAdminMobileNo(e.target.value)} 
            />
            <br />
            <input type='text' className='form-control' placeholder='Club Sponsored By' onChange={(e) => setClubSponsoredBy(e.target.value)} />
            <br />
            <input type='date' className='form-control' placeholder='Charted On' onChange={(e) => setChartedOn(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Charter President' onChange={(e) => setCharter(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Extn Chairperson' onChange={(e) => setExtn(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Meets On' onChange={(e) => setMeets(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Place' onChange={(e) => setPlace(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Region Chairperson' onChange={(e) => setRegion(e.target.value)} />
            <br />
            <input
  type='text'
  className='form-control'
  placeholder='Region Chairperson Mobile No'
  onChange={(e) => setRegionMobileNo(e.target.value)}
/>
<br />
            <input type='text' className='form-control' placeholder='Zone Chairperson' onChange={(e) => setZone(e.target.value)} />
            <br />
            <input
  type='text'
  className='form-control'
  placeholder='Zone Chairperson Mobile No'
  onChange={(e) => setZoneMobileNo(e.target.value)}
/>
<br />
            <input type='text' className='form-control' placeholder='Total Members' onChange={(e) => setTotalMembers(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Category' onChange={(e) => setCategory(e.target.value)} />
            <br />
            <button type='submit' className='btn btn-danger form-control'>Submit</button>
            <br />
            <br />
            <button type='reset' className='btn btn-secondary form-control'>Reset</button>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showUpload} onHide={handleUploadClose}>
  <Modal.Header closeButton>
    <Modal.Title>Upload Club Excel</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <input 
      type="file" 
      accept=".xlsx, .xls" 
      className="form-control"
      onChange={(e) => setFile(e.target.files[0])}
    />
    <br />

    <button 
      className="btn btn-success form-control"
      onClick={uploadBulk}
    >
      Upload
    </button>
    
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleUploadClose}>
      Close
    </Button>
  </Modal.Footer>
</Modal>
      <FaSearch className='searchIcon'></FaSearch><input type='search' className='ms-4 search-input-field' placeholder='Search..' onChange={(e)=>searchHandler(e.target.value)} />
      <div style={{ marginTop: '1rem' }} className='table-container'>
        <table className="styled-table table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Club_Name</th>
              <th>Club_Number</th>
              <th>President</th>
                     <th>President_Mobile_No</th> {/* Added this column */}
        <th>Secretary</th>
        <th>Secretary_Mobile_No</th> {/* Added this column */}
              <th>Treasurer</th>
              <th>Treasurer_Mobile_No</th>
              <th>Club_Administrator</th>
              <th>Club_Admin_Mobile_No</th>
              <th>Club_Sponsored_By</th>
              <th>Charted_On</th>
              <th>Place</th>
              <th>Region_Chairperson</th>
     <th>Region_Mobile_No</th>
              <th>Zone_Chairperson</th>
                       <th>Zone_Mobile_No</th>
              <th>Total_Mambers</th>
            <th>Update</th>
        <th>Delete</th>
            </tr>

          </thead>
          <tbody className='table-bordered'>
            {
              club.slice(pagination.start, pagination.end).map((data, index) => {
                return (
                  <tr>
                    <td>{pagination.start + index + 1}</td>
                    <td>{data.clubName}</td>
                    <td>{data.clubNumber}</td>
                    <td>{data.president}</td>
                      <td>{data.president_mobileNo}</td> 
                    <td>{data.secretory}</td>
                     <td>{data.secretary_mobileNo}</td> 
                    <td>{data.treasurer}</td>
                    <td>{data.treasurer_mobileNo}</td>
                    <td>{data.clubAdministrator}</td>
                    <td>{data.clubAdmin_mobileNo}</td>
                    <td>{data.clubSponsoredBy}</td>
                    <td>{data.chartedOn}</td>
                    <td>{data.place}</td>
                    <td>{data.regionChairperson}</td>
                    <td>{data.region_mobileNo}</td>

                    <td>{data.zoneChairperson}</td>
                    <td>{data.zone_mobileNo}</td>
                    <td>{data.totalMembers}</td>
                  <td className=''>
                      <Link to={`/update-club/${data.clubName}/${data.clubNumber}`} className='btn btn-info' style={{ color: 'white' }}>update</Link>
                    </td>
                 <td className=''>
                      <Link to='#' className='btn btn-danger' onClick={() => deleteData(data.clubId)}>delete</Link>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <Pagination page={showPerPage} onChangePagination={onChangePagination} total={club.length} />
      </div>
    </>
  )
}

export default ViewClub